const CategorySkeleton = () => {
    return (
        <div className="categoryLayoutList">
            <div className="cateLayDiv">
                <div className="skeleton" style={{ height: 64, width: 64 }} />
                <div className="skeleton" style={{ height: 18, width: "30%", marginTop: 10 }} />
            </div>
        </div>
    );
};

export default CategorySkeleton;
